const countries = [
    { text: "Afganistán", value: "Afganistán" },
    { text: "Islas Åland", value: "Islas Åland" },
    { text: "Albania", value: "Albania" },
    { text: "Alemania", value: "Alemania" },
    { text: "Andorra", value: "Andorra" },
    { text: "Angola", value: "Angola" },
    { text: "Anguilla", value: "Anguilla" },
    { text: "Antártida", value: "Antártida" },
    { text: "Antigua y Barbuda", value: "Antigua y Barbuda" },
    { text: "Antillas Holandesas", value: "Antillas Holandesas" },
    { text: "Arabia Saudí", value: "Arabia Saudí" },
    { text: "Argelia", value: "Argelia" },
    { text: "Argentina", value: "Argentina" },
    { text: "Armenia", value: "Armenia" },
    { text: "Aruba", value: "Aruba" },
    { text: "Australia", value: "Australia" },
    { text: "Austria", value: "Austria" },
    { text: "Azerbaiyán", value: "Azerbaiyán" },
    { text: "Bahamas", value: "Bahamas" },
    { text: "Bahréin", value: "Bahréin" },
    { text: "Bangladesh", value: "Bangladesh" },
    { text: "Barbados", value: "Barbados" },
    { text: "Bielorrusia", value: "Bielorrusia" },
    { text: "Bélgica", value: "Bélgica" },
    { text: "Belice", value: "Belice" },
    { text: "Benin", value: "Benin" },
    { text: "Bermudas", value: "Bermudas" },
    { text: "Bhután", value: "Bhután" },
    { text: "Bolivia", value: "Bolivia" },
    { text: "Bosnia y Herzegovina", value: "Bosnia y Herzegovina" },
    { text: "Botsuana", value: "Botsuana" },
    { text: "Isla Bouvet", value: "Isla Bouvet" },
    { text: "Brasil", value: "Brasil" },
    { text: "Brunéi", value: "Brunéi" },
    { text: "Bulgaria", value: "Bulgaria" },
    { text: "Burkina Faso", value: "Burkina Faso" },
    { text: "Burundi", value: "Burundi" },
    { text: "Cabo Verde", value: "Cabo Verde" },
    { text: "Islas Caimán", value: "Islas Caimán" },
    { text: "Camboya", value: "Camboya" },
    { text: "Camerún", value: "Camerún" },
    { text: "Canadá", value: "Canadá" },
    { text: "República Centroafricana", value: "República Centroafricana" },
    { text: "Chad", value: "Chad" },
    { text: "República Checa", value: "República Checa" },
    { text: "Chile", value: "Chile" },
    { text: "China", value: "China" },
    { text: "Chipre", value: "Chipre" },
    { text: "Isla de Navidad", value: "Isla de Navidad" },
    { text: "Ciudad del Vaticano", value: "Ciudad del Vaticano" },
    { text: "Islas Cocos", value: "Islas Cocos" },
    { text: "Colombia", value: "Colombia" },
    { text: "Comoras", value: "Comoras" },
    { text: "República Democrática del Congo", value: "República Democrática del Congo" },
    { text: "Congo", value: "Congo" },
    { text: "Islas Cook", value: "Islas Cook" },
    { text: "Corea del Norte", value: "Corea del Norte" },
    { text: "Corea del Sur", value: "Corea del Sur" },
    { text: "Costa de Marfil", value: "Costa de Marfil" },
    { text: "Costa Rica", value: "Costa Rica" },
    { text: "Croacia", value: "Croacia" },
    { text: "Cuba", value: "Cuba" },
    { text: "Dinamarca", value: "Dinamarca" },
    { text: "Dominica", value: "Dominica" },
    { text: "República Dominicana", value: "República Dominicana" },
    { text: "Ecuador", value: "Ecuador" },
    { text: "Egipto", value: "Egipto" },
    { text: "El Salvador", value: "El Salvador" },
    { text: "Emiratos Árabes Unidos", value: "Emiratos Árabes Unidos" },
    { text: "Eritrea", value: "Eritrea" },
    { text: "Eslovaquia", value: "Eslovaquia" },
    { text: "Eslovenia", value: "Eslovenia" },
    { text: "España", value: "España" },
    { text: "Islas ultramarinas de Estados Unidos", value: "Islas ultramarinas de Estados Unidos" },
    { text: "Estados Unidos", value: "Estados Unidos" },
    { text: "Estonia", value: "Estonia" },
    { text: "Etiopía", value: "Etiopía" },
    { text: "Islas Feroe", value: "Islas Feroe" },
    { text: "Filipinas", value: "Filipinas" },
    { text: "Finlandia", value: "Finlandia" },
    { text: "Fiyi", value: "Fiyi" },
    { text: "Francia", value: "Francia" },
    { text: "Gabón", value: "Gabón" },
    { text: "Gambia", value: "Gambia" },
    { text: "Georgia", value: "Georgia" },
    { text: "Islas Georgias del Sur y Sandwich del Sur", value: "Islas Georgias del Sur y Sandwich del Sur" },
    { text: "Ghana", value: "Ghana" },
    { text: "Gibraltar", value: "Gibraltar" },
    { text: "Granada", value: "Granada" },
    { text: "Grecia", value: "Grecia" },
    { text: "Groenlandia", value: "Groenlandia" },
    { text: "Guadalupe", value: "Guadalupe" },
    { text: "Guam", value: "Guam" },
    { text: "Guatemala", value: "Guatemala" },
    { text: "Guayana Francesa", value: "Guayana Francesa" },
    { text: "Guinea", value: "Guinea" },
    { text: "Guinea Ecuatorial", value: "Guinea Ecuatorial" },
    { text: "Guinea-Bissau", value: "Guinea-Bissau" },
    { text: "Guyana", value: "Guyana" },
    { text: "Haití", value: "Haití" },
    { text: "Islas Heard y McDonald", value: "Islas Heard y McDonald" },
    { text: "Honduras", value: "Honduras" },
    { text: "Hong Kong", value: "Hong Kong" },
    { text: "Hungría", value: "Hungría" },
    { text: "India", value: "India" },
    { text: "Indonesia", value: "Indonesia" },
    { text: "Irán", value: "Irán" },
    { text: "Iraq", value: "Iraq" },
    { text: "Irlanda", value: "Irlanda" },
    { text: "Islandia", value: "Islandia" },
    { text: "Israel", value: "Israel" },
    { text: "Italia", value: "Italia" },
    { text: "Jamaica", value: "Jamaica" },
    { text: "Japón", value: "Japón" },
    { text: "Jordania", value: "Jordania" },
    { text: "Kazajstán", value: "Kazajstán" },
    { text: "Kenia", value: "Kenia" },
    { text: "Kirguistán", value: "Kirguistán" },
    { text: "Kiribati", value: "Kiribati" },
    { text: "Kuwait", value: "Kuwait" },
    { text: "Laos", value: "Laos" },
    { text: "Lesotho", value: "Lesotho" },
    { text: "Letonia", value: "Letonia" },
    { text: "Líbano", value: "Líbano" },
    { text: "Liberia", value: "Liberia" },
    { text: "Libia", value: "Libia" },
    { text: "Liechtenstein", value: "Liechtenstein" },
    { text: "Lituania", value: "Lituania" },
    { text: "Luxemburgo", value: "Luxemburgo" },
    { text: "Macao", value: "Macao" },
    { text: "ARY Macedonia", value: "ARY Macedonia" },
    { text: "Madagascar", value: "Madagascar" },
    { text: "Malasia", value: "Malasia" },
    { text: "Malawi", value: "Malawi" },
    { text: "Maldivas", value: "Maldivas" },
    { text: "Malí", value: "Malí" },
    { text: "Malta", value: "Malta" },
    { text: "Islas Malvinas", value: "Islas Malvinas" },
    { text: "Islas Marianas del Norte", value: "Islas Marianas del Norte" },
    { text: "Marruecos", value: "Marruecos" },
    { text: "Islas Marshall", value: "Islas Marshall" },
    { text: "Martinica", value: "Martinica" },
    { text: "Mauricio", value: "Mauricio" },
    { text: "Mauritania", value: "Mauritania" },
    { text: "Mayotte", value: "Mayotte" },
    { text: "México", value: "México" },
    { text: "Micronesia", value: "Micronesia" },
    { text: "Moldavia", value: "Moldavia" },
    { text: "Mónaco", value: "Mónaco" },
    { text: "Mongolia", value: "Mongolia" },
    { text: "Montserrat", value: "Montserrat" },
    { text: "Mozambique", value: "Mozambique" },
    { text: "Myanmar", value: "Myanmar" },
    { text: "Namibia", value: "Namibia" },
    { text: "Nauru", value: "Nauru" },
    { text: "Nepal", value: "Nepal" },
    { text: "Nicaragua", value: "Nicaragua" },
    { text: "Níger", value: "Níger" },
    { text: "Nigeria", value: "Nigeria" },
    { text: "Niue", value: "Niue" },
    { text: "Isla Norfolk", value: "Isla Norfolk" },
    { text: "Noruega", value: "Noruega" },
    { text: "Nueva Caledonia", value: "Nueva Caledonia" },
    { text: "Nueva Zelanda", value: "Nueva Zelanda" },
    { text: "Omán", value: "Omán" },
    { text: "Países Bajos", value: "Países Bajos" },
    { text: "Pakistán", value: "Pakistán" },
    { text: "Palau", value: "Palau" },
    { text: "Palestina", value: "Palestina" },
    { text: "Panamá", value: "Panamá" },
    { text: "Papúa Nueva Guinea", value: "Papúa Nueva Guinea" },
    { text: "Paraguay", value: "Paraguay" },
    { text: "Perú", value: "Perú" },
    { text: "Pitcairn", value: "Pitcairn" },
    { text: "Polinesia Francesa", value: "Polinesia Francesa" },
    { text: "Polonia", value: "Polonia" },
    { text: "Portugal", value: "Portugal" },
    { text: "Puerto Rico", value: "Puerto Rico" },
    { text: "Qatar", value: "Qatar" },
    { text: "Reino Unido", value: "Reino Unido" },
    { text: "Reunión", value: "Reunión" },
    { text: "Ruanda", value: "Ruanda" },
    { text: "Rumanía", value: "Rumanía" },
    { text: "Rusia", value: "Rusia" },
    { text: "Islas Salomón", value: "Islas Salomón" },
    { text: "Samoa", value: "Samoa" },
    { text: "Samoa Americana", value: "Samoa Americana" },
    { text: "San Cristóbal y Nevis", value: "San Cristóbal y Nevis" },
    { text: "San Marino", value: "San Marino" },
    { text: "San Pedro y Miquelón", value: "San Pedro y Miquelón" },
    { text: "San Vicente y las Granadinas", value: "San Vicente y las Granadinas" },
    { text: "Santa Elena", value: "Santa Elena" },
    { text: "Santa Lucía", value: "Santa Lucía" },
    { text: "Santo Tomé y Príncipe", value: "Santo Tomé y Príncipe" },
    { text: "Senegal", value: "Senegal" },
    { text: "Serbia y Montenegro", value: "Serbia y Montenegro" },
    { text: "Seychelles", value: "Seychelles" },
    { text: "Sierra Leona", value: "Sierra Leona" },
    { text: "Singapur", value: "Singapur" },
    { text: "Siria", value: "Siria" },
    { text: "Somalia", value: "Somalia" },
    { text: "Sri Lanka", value: "Sri Lanka" },
    { text: "Suazilandia", value: "Suazilandia" },
    { text: "Sudáfrica", value: "Sudáfrica" },
    { text: "Sudán", value: "Sudán" },
    { text: "Suecia", value: "Suecia" },
    { text: "Suiza", value: "Suiza" },
    { text: "Surinam", value: "Surinam" },
    { text: "Svalbard y Jan Mayen", value: "Svalbard y Jan Mayen" },
    { text: "Tailandia", value: "Tailandia" },
    { text: "Taiwán", value: "Taiwán" },
    { text: "Tanzania", value: "Tanzania" },
    { text: "Tayikistán", value: "Tayikistán" },
    { text: "Territorio Británico del Océano Índico", value: "Territorio Británico del Océano Índico" },
    { text: "Territorios Australes Franceses", value: "Territorios Australes Franceses" },
    { text: "Timor Oriental", value: "Timor Oriental" },
    { text: "Togo", value: "Togo" },
    { text: "Tokelau", value: "Tokelau" },
    { text: "Tonga", value: "Tonga" },
    { text: "Trinidad y Tobago", value: "Trinidad y Tobago" },
    { text: "Túnez", value: "Túnez" },
    { text: "Turkmenistán", value: "Turkmenistán" },
    { text: "Turquía", value: "Turquía" },
    { text: "Tuvalu", value: "Tuvalu" },
    { text: "Ucrania", value: "Ucrania" },
    { text: "Uganda", value: "Uganda" },
    { text: "Uruguay", value: "Uruguay" },
    { text: "Uzbekistán", value: "Uzbekistán" },
    { text: "Vanuatu", value: "Vanuatu" },
    { text: "Venezuela", value: "Venezuela" },
    { text: "Vietnam", value: "Vietnam" },
    { text: "Wallis y Futuna", value: "Wallis y Futuna" },
    { text: "Yemen", value: "Yemen" },
    { text: "Zambia", value: "Zambia" },
    { text: "Zimbabue", value: "Zimbabue" }
  ];

export default countries;